import { createAction } from 'redux-act'

export const setSnackBar = createAction('setSnackBar')
export const showSnackBar = createAction('setSnackBar')
